import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { Fade } from "react-reveal";
import toastr from "toastr";
import { Alert, Spinner } from "reactstrap";
import { registerUser, getKyc, getKycStatus } from "store/actions";
import Loader from "Component/Common/Loader";
import { useDispatch, useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import { uploadFileRequest } from "store/actions";
import { useNavigate, useLocation } from "react-router-dom";
import { useKycStatus } from "helpers/custom-hooks";
import bannerImg from '../../assets/images/kyc.png'
import hurry from '../../assets/images/hurry.gif'

import pending from '../../assets/images/pending.gif'
import useToastr from "helpers/toastr";
import rejected from '../../assets/images/denied.gif'
import { useTranslation } from 'react-i18next';


const fileTypes = ["JPG", "PNG", "GIF"];

const KYC = () => {
  const toastr = useToastr();
  const navigate = useNavigate();

  const location = useLocation();
  const dispatch = useDispatch();
  const url = location?.state?.kycUrl;
  const { user } = useSelector(({ Login }) => Login);
  const [kycUrl, setKycUrl] = useState();
  const [kycInfo, setKycInfo] = useState();
  const iframeRef = useRef();
  const isVerified = useKycStatus();
  const { t } = useTranslation();


  /**
     * Used for getting the status of kyc from api
     */
  useEffect(() => {
    if (user?._id) {
      const callBack = (response) => {
        if (response.status == "success") {
          setKycInfo(response?.data?.kycDetails)
          setKycUrl(response?.data?.kycDetails?.form_url)

          if (Object.keys(response.data).length === 0) {
            const kycCallBack = (response) => {
              if (response.status == "success") {
                let url = response?.data?.formResponse?.form_url;
                setKycUrl(url)
              } else {

              }
            }
            dispatch(getKyc({ _id: user?._id }, kycCallBack))
          }
        }
      }
      dispatch(getKycStatus({ _id: user?._id }, callBack))
    }
  }, [kycUrl])

    /**
     * Used for render the UI for try again
     */
  const kycTryAgain = () => {
    const kycCallBack = (response) => {
      if (response.status == "success") {
        let url = response?.data?.formResponse?.form_url;
        setKycUrl(url)
      }
    }
    dispatch(getKyc({ _id: user?._id }, kycCallBack))
  }



  const handleBack = () => {
    navigate('/');
  }

  /**
     * Used for render the UI for kyc view
     */

  return (
    <section className="common_sign_main sign_in kyc_main p-3">
      <Container>



        <div className="common_sign_inner">

          <Row>
            <Col lg={7} md={6} sm={12} className="order-1 order-lg-1">

              <div className="text-start">
                <svg role="button" onClick={handleBack} width="30" height="30" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M13 5H1m0 0 4 4M1 5l4-4" />
                </svg>
              </div>

              {
                kycInfo?.status == "unused" &&

                <h5 className="my-5">{t('kyc_note')}
                </h5>
              }

              {
                kycInfo?.status == "completed" && kycInfo?.verified == true &&
                <Fade>

                  <div className="kyc_hero_img text-center">
                    <div className="hurry">
                      <img alt="heroImage" src={hurry} className="img-fluid" />
                    </div>
                    <h2>{t('congratulations')} !</h2>
                    <h4> {t('kyc_completed')}</h4>
                    <img alt="heroImage" src={bannerImg} className="img-fluid" />
                  </div>
                </Fade>


              }
              {
                (kycInfo?.status == "unused" || kycInfo == undefined) &&
                <Fade>

                  <div className="KYC_Left_part">
                    <iframe ref={iframeRef} src={kycUrl} title="W3Schools Free Online Web Tutorials">
                    </iframe>
                  </div>
                </Fade>

              }

              {
                kycInfo?.status == "pending" &&
                <Fade>

                  <div className="kyc_hero_img text-center">
                    <div className="pending">
                      <img alt="heroImage" src={pending} className="img-fluid" />
                    </div>
                    <h5 className="pending_col"> {t('kyc_under_review')}</h5>
                    <img alt="heroImage" src={bannerImg} className="img-fluid" />
                  </div>
                </Fade>

              }

              {
                kycInfo?.status == "completed" && kycInfo?.verified == false &&
                <Fade>

                  <div className="kyc_hero_img text-center">
                    <div className="rejected">
                      <img alt="heroImage" src={rejected} className="img-fluid" />
                    </div>
                    <h5 className="rejected_col"> {t('kyc_rejected')}</h5>
                    <img alt="heroImage" src={bannerImg} className="img-fluid" />
                  </div>
                </Fade>

              }




            </Col>

            <Col lg={5} md={6} sm={12} className="order-2 order-lg-2">
              <Fade>
                <div className="position-relative KYC_status">
                  <div className="kyc_right_content">
                    <h5>{t('kyc_status')}</h5>
                    <ul>
                      {/* {
                        kycInfo?.status == "unused" &&
                        <li>{t('status')} - <span className="status pending">
                          {t('unused')}
                        </span></li>
                      } */}
                      {
                        kycInfo?.status == "completed" && kycInfo?.verified == false &&
                        <li>{t('status')}  - <span className="status rejected">
                          {t('rejected')}
                        </span></li>
                      }
                      {
                        kycInfo?.status == "pending" || kycInfo?.status == "unused" ?
                        <li>{t('status')}  - <span className="status pending">
                          {t('pending')}

                        </span></li>
                        :""

                      }

                      {
                        kycInfo?.status == "completed" && kycInfo?.verified == true &&
                        <li>{t('status')}  - <span className="status Approved">
                          {t('approved')}

                        </span></li>

                      }
                    </ul>
                    {
                      kycInfo?.status == "completed" && kycInfo?.verified == false &&
                      <Button className="kyctryagain mt-3 w-100" onClick={kycTryAgain} >

                        {t('try_again')}
                      </Button>
                    }

                  </div>
                </div>
              </Fade>

            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default KYC;
